(function () {
  var motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  function initSection(section) {
    if (!section || typeof window.Swiper === "undefined") return;

    var el = section.querySelector("[data-rs-swiper]");
    if (!el) return;

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    new window.Swiper(el, {
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 16,
      speed: motionQuery.matches ? 0 : 720,
      watchOverflow: true,
      roundLengths: true,
      grabCursor: true,
      threshold: 8,
      resistanceRatio: 0.72,
      longSwipesRatio: 0.28,
      touchStartPreventDefault: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        prevEl: section.querySelector("[data-rs-prev]"),
        nextEl: section.querySelector("[data-rs-next]"),
      },
      a11y: {
        prevSlideMessage: "Previous products",
        nextSlideMessage: "Next products",
      },
    });
  }

  function boot(root, attempts) {
    var tries = attempts || 0;
    var scope = root && root.querySelectorAll ? root : document;
    if (typeof window.Swiper === "undefined") {
      if (tries > 40) return;
      window.setTimeout(function () {
        boot(scope, tries + 1);
      }, 50);
      return;
    }
    scope.querySelectorAll('[data-section-type="regulatory-status"]').forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-section-type="regulatory-status"]').forEach(function (section) {
      var el = section.querySelector("[data-rs-swiper]");
      if (el && el.swiper) el.swiper.destroy(true, true);
    });
  });
})();
